import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import { cn } from "@/lib/helper/utils";
import { FC, Fragment } from "react";
import { Link } from "react-router-dom";
import { RiShareForwardFill } from "react-icons/ri";

type BreadCrumbWithBack = {
  hasBack?: boolean;
  linkBack?: string;
  data: {
    title: string;
    link?: string;
  }[];
  className?: string;
};
const BreadCrumbWithBack: FC<BreadCrumbWithBack> = ({
  hasBack,
  linkBack,
  data,
  className,
}) => {
  return (
    <div className={cn("flex items-center gap-1", className)}>
      {hasBack && linkBack && (
        <Link to={linkBack} className="flex flex-row bg-primary text-white px-4 py-1 rounded-2xl items-center gap-1">
          <RiShareForwardFill  className="text-xl w-[32px] h-[24px] -mr-1.5" />
          <span>بازگشت به کارتخوان مجازی</span>
        </Link>
      )}
      <Breadcrumb >
        <BreadcrumbList className="sm:gap-2">
          {data.map((item, index) => (
            <Fragment key={index} >
              <BreadcrumbItem className="gap-3">
                {item.link && index !== data.length - 1 ? (
                  <BreadcrumbLink to={item.link}>{item.title}</BreadcrumbLink>
                ) : (
                  <BreadcrumbPage>{item.title}</BreadcrumbPage>
                )}
              </BreadcrumbItem>
              {item.link && index !== data.length - 1 && (
                <BreadcrumbSeparator />
              )}
            </Fragment>
          ))}
        </BreadcrumbList>
      </Breadcrumb>
    </div>
  );
};

export default BreadCrumbWithBack;
